import React from 'react'
import { Modal as ReactstrapModal, ModalHeader, ModalBody, FormGroup } from 'reactstrap'
import Button from 'components/Button'
import Icon from 'components/Icon'
import styles from './Modal.scss'

const allowedSizes = ['sm', 'md', 'lg', 'xl'] as const
type ModalSize = typeof allowedSizes[number]
const [SIZE_SM, SIZE_MD] = allowedSizes

interface ModalProps {
  isOpen?: boolean
  size?: ModalSize
  onClose: () => void
  header?: React.ReactNode
  children: React.ReactNode
  className?: string
  headerClassName?: string
  style?: React.CSSProperties
}

interface ModalAction {
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'link'
  label: string
  isDisplayed?: boolean
  [key: string]: any
}

interface ModalActionsProps {
  actions: ModalAction[]
}

export const Modal: React.FC<ModalProps> = ({
  isOpen = false,
  size = SIZE_SM,
  onClose,
  header,
  children,
  className,
  headerClassName,
  style = {},
}) => (
  <ReactstrapModal isOpen={isOpen} size={size} toggle={onClose} className={className}>
    {header && (
      <ModalHeader toggle={onClose} className={headerClassName}>
        <div className={styles.header}>{header}</div>
        <Button buttonType='transparent' onClick={onClose} className={styles.close}>
          <Icon name='close' size='regular' />
        </Button>
      </ModalHeader>
    )}
    <ModalBody style={style}>{children}</ModalBody>
  </ReactstrapModal>
)

export const ModalActions: React.FC<ModalActionsProps> = ({ actions }) => (
  <FormGroup className={styles.actions}>
    {actions
      .filter(({ isDisplayed = true }) => isDisplayed)
      .map(({ color = 'primary', label, isDisplayed, ...rest }) => (
        <Button {...rest} color={color} className={styles.action} key={label}>
          {label}
        </Button>
      ))}
  </FormGroup>
) 